var ns, kendo;
ns.App.factory('DsFactory', function(BRIEF_PARAM){
  return {
    create: function(dsConf, endpoint, isBrief){
      //デフォルト引数
      if (typeof isBrief === 'undefined') {
        isBrief = true;
      }
      if(isBrief){
        if (endpoint.indexOf('?') === -1) {
          endpoint += "?" + BRIEF_PARAM;
        }else{
          endpoint += "&" + BRIEF_PARAM;
        }
      }
      dsConf.transport.read.url = endpoint;
      return new kendo.data.DataSource(dsConf);
    },
    createPost: function(dsConf, endpoint, params){
      //デフォルト引数
      if (typeof isBrief === 'undefined') {
        isBrief = true;
      }
      dsConf.transport.read.url = endpoint;
      dsConf.transport.read.beforeSend = function (xhr) { return xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name=csrf-token]').attr('content')); };
      dsConf.transport.read.type = "POST";
      dsConf.transport.read.data = params;
      return new kendo.data.DataSource(dsConf);
    }
  };
});

